import ReactDOM from 'react-dom'

import '@aytm/lib/tailwind/index.css'
import UUIAYTMTheme from '@aytm/lib/uui/theme/aytm'
import UUIThemeContext from '@aytm/lib/uui/theme/context'

import { LoginForm } from './components/LoginForm'
import { LoginPageProps } from './types'

function LoginPage(props: LoginPageProps) {
  const root = document.querySelector('#content')
  if (!root) return

  ReactDOM.render(
    <UUIThemeContext.Provider value={UUIAYTMTheme}>
      <LoginForm {...props} />
    </UUIThemeContext.Provider>,
    root
  )
}

;(window as unknown as { LoginPage: typeof LoginPage }).LoginPage = LoginPage
